import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ui-breadcrumb',
    templateUrl: './ui-breadcrumb.component.html',
    styleUrls: ['./ui-breadcrumb.component.scss'],
    standalone: false
})
export class UiBreadcrumbComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
